"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavSettings = _interopRequireDefault(require("../NavSettings/NavSettings"));

var _NavToolbar = _interopRequireDefault(require("../NavToolbar/NavToolbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  settings: {
    display: "flex"
  },
  toolbar: {
    display: "flex"
  }
}));

const getToolbar = ({
  editable,
  onEdit,
  removable,
  onRemove,
  deletable,
  onDelete,
  restorable,
  onRestore
}) => {
  let toolbar = [];

  if (editable || deletable || removable) {
    if (editable && onEdit) {
      toolbar.push({
        icon: "edit",
        onClick: onEdit
      });
    }

    if (removable && onRemove) {
      toolbar.push({
        icon: "remove_circle",
        onClick: onRemove
      });
    } else if (deletable && onDelete) {
      toolbar.push({
        icon: "delete",
        onClick: onDelete
      });
    } else if (restorable && onRestore) {
      toolbar.push({
        icon: "restore",
        onClick: onRestore
      });
    }
  }

  return toolbar;
};

const ModuleActionbar = (_ref) => {
  let className = _ref.className,
      settings = _ref.settings,
      toolbar = _ref.toolbar,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "settings", "toolbar", "children"]);

  const classes = useStyles();

  if (children) {
    return _react.default.createElement("div", {
      className: className || classes.root
    }, children);
  }

  if (!toolbar) {
    toolbar = getToolbar(props);
  }

  if (settings || toolbar) {
    return _react.default.createElement("div", {
      className: className || classes.root
    }, settings && _react.default.createElement(_NavSettings.default, {
      className: classes.settings,
      settings: settings
    }), toolbar && _react.default.createElement(_NavToolbar.default, {
      className: classes.toolbar,
      toolbar: toolbar
    }));
  }

  return false;
};

ModuleActionbar.propTypes = process.env.NODE_ENV !== "production" ? {
  settings: _propTypes.default.array,
  toolbar: _propTypes.default.array
} : {};
var _default = ModuleActionbar;
exports.default = _default;
module.exports = exports.default;